import './app/layout/styles.css';
import 'mobx-react-lite/batchingForReactDom';
import 'react-toastify/dist/ReactToastify.min.css';

import { createBrowserHistory } from 'history';
import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';

import App from './app/layout/App';
import ScrollToTop from './app/layout/ScrollToTop';
import * as serviceWorker from './serviceWorker';

export const history = createBrowserHistory();

ReactDOM.render(
  //<React.StrictMode>
  <Router history={history}>
    <ScrollToTop>
      <App />
    </ScrollToTop>
  </Router>,
  //</React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
